module.exports = __webpack_public_path__ + "a8ec4278627e5fa78bbcedb4b5ca9db1.svg";


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-flag-kit/assets/WW.svg
// module id = ASSR
// module chunks = 0